import { TinyColor } from '@ctrl/tinycolor';
import React, { forwardRef, useState } from 'react';
import { TextInput as ReactTextInput } from 'react-native';
import { Hoverable } from 'react-native-web-hover';
import styled from 'styled-components/native';
import { color, spacing, typography } from '../../theme';
import Text from '../Text';
import { TextInputPresets } from './TextInput.presets';
import { TextInputProps } from './TextInput.props';

/**
 * For your text input displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
// eslint-disable-next-line react/display-name
export const TextInput = forwardRef<ReactTextInput, TextInputProps>(
  (props, ref) => {
    const {
      preset = 'default',
      error,
      style,
      containerStyle,
      textInputStyle,
      ...rest
    } = props;

    const [borderColor, setBorderColor] = useState<string>(
      preset === 'default' ? color.formElement : color.primaryIcon
    );

    const onBlur = (e: any) => {
      setBorderColor(color.formElement);
      rest.onBlur?.(e);
    };

    const onFocus = (e: any) => {
      setBorderColor(color.primaryIcon);
      rest.onFocus?.(e);
    };

    return (
      <>
        <Hoverable style={[style, containerStyle]}>
          {({ hovered }) => (
            <Input
              {...rest}
              ref={ref}
              hovered={hovered}
              borderColor={borderColor}
              preset={preset}
              onBlur={onBlur}
              onFocus={onFocus}
              style={[style, textInputStyle]}
            />
          )}
        </Hoverable>
        {error && <Text preset="error">{error.message}</Text>}
      </>
    );
  }
);

const Input = styled(ReactTextInput)<{
  hovered?: boolean;
  borderColor: string;
  preset: TextInputPresets;
}>`
  height: 56px;
  min-height: 56px;
  border-color: ${color.formElement};
  min-width: 210px;
  border-width: 2px;
  border-radius: 10px;
  padding: 0 ${spacing[4]}px;
  font-family: ${typography.primary.regular};
  color: ${color.text};
  font-size: 18px;
  ${({ hovered, borderColor, preset }) => `
    border-color: ${
      hovered
        ? new TinyColor(borderColor).darken(20).toHexString()
        : borderColor
    };
    ${presets[preset] || ''}
  `}
`;
const presets = {
  secondary: `border-color: ${color.secondary}; background-color: ${color.secondary};`,
  focus: `border-color: ${color.primaryIcon};`,
};
